import { useQuery } from "@tanstack/react-query";

import { apiFetch } from "@/lib/api";

export type StatoEmail = "inviata" | "errore" | "bloccata" | "trattenuta" | "in_corso";

export interface EmailThreadRow {
  id: string;
  tipo: "carico" | "orfana";
  cliente: string;
  paese_iso: string | null;
  oggetto: string | null;
  stato: StatoEmail;
  n_allegati: number;
  ultima_attivita_il: string | null;
}

export interface Allegato {
  id: string;
  nome: string;
}

export interface EventoRicevuta {
  tipo: "ricevuta";
  mittente: string | null;
  oggetto: string | null;
  corpo: string | null;
  quando: string;
  allegati: Allegato[];
}

export interface EventoOperazioni {
  tipo: "operazioni";
  quando: string;
  voci: { titolo: string; dettaglio: string | null }[];
}

export interface EventoInviata {
  tipo: "inviata";
  destinatari: string[];
  oggetto: string | null;
  corpo: string | null;
  stato_invio: string;
  inviato_il: string | null;
  errore_invio: string | null;
  quando: string;
  allegati: Allegato[];
}

export type EventoThread = EventoRicevuta | EventoOperazioni | EventoInviata;

export interface EmailThreadDetail {
  id: string;
  tipo: "carico" | "orfana";
  cliente: string | null;
  paese_iso: string | null;
  riferimento: string | null;
  stato: string;
  motivo: string | null;
  eventi: EventoThread[];
}

export interface EmailFiltri {
  stato?: string;
  paese?: string;
  q?: string;
}

export function useAgenteEmail(slug: string | undefined, filtri: EmailFiltri = {}) {
  const params = new URLSearchParams();
  if (filtri.stato && filtri.stato !== "tutte") params.set("stato", filtri.stato);
  if (filtri.paese) params.set("paese", filtri.paese);
  if (filtri.q) params.set("q", filtri.q);
  const qs = params.toString();
  return useQuery({
    queryKey: ["admin", "agente", slug, "email", filtri],
    queryFn: () =>
      apiFetch<{ email: EmailThreadRow[] }>(
        `/api/v1/admin/agenti/${slug}/email${qs ? `?${qs}` : ""}`,
      ),
    enabled: !!slug,
  });
}

export function useAgenteEmailThread(
  slug: string | undefined,
  threadId: string | null,
) {
  return useQuery({
    queryKey: ["admin", "agente", slug, "email", "thread", threadId],
    queryFn: () =>
      apiFetch<EmailThreadDetail>(
        `/api/v1/admin/agenti/${slug}/email/${threadId}`,
      ),
    enabled: !!slug && !!threadId,
  });
}
